import {
    GET_PURCHASERECONCILIATION,
    GET_STATE_LOADING,
    GET_CHANGESTATE_LIST_TYPE_STATE
    
} from "@/views/purchase_reconciliation/store/types/types.js";

const getters = {
    [GET_PURCHASERECONCILIATION]: state => state.purchaseReconciliation,
    [GET_STATE_LOADING]: state => state.loading,
    [GET_CHANGESTATE_LIST_TYPE_STATE]: state => state.typeChangeState

};

export default getters;